import React, {Component} from "react";
import FormatMessage from "../messages/FormatMessage";
import {popupWin} from "../assets-static/scripts/utils";

class EQFooter extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if(window.dataLayer){
            window.dataLayer.push({
                virtualPagePath: window.location.pathname.replace("/interactions/eq/users/0/applications/0/pages","")
            })
        }
    }

    render() {
        return (<div className="SiteFooter">
            <div className="SiteFooter-layout">
                <div className="FooterLinks SiteFooter-links">
                    <FormatMessage id="applicationcenter.footer.privacy">
                        {(message) => !message.toString().includes("applicationcenter.footer.privacy") ?
                            <div className="FooterLinks-item">
                                <a className="FooterLinks-link" href="#" onClick={() => popupWin("/application-center/privacy-policy")}>
                                    {message}
                                </a>
                            </div> : ""}
                    </FormatMessage>
                    <FormatMessage id="applicationcenter.footer.termsofuse">
                        {(message) => !message.toString().includes("applicationcenter.footer.termsofuse") ?
                            <div className="FooterLinks-item">
                                <a className="FooterLinks-link" href="#" onClick={() => popupWin("/application-center/terms-of-use")}>
                                    {message}
                                </a>
                            </div> : ""}
                    </FormatMessage>
                    <FormatMessage id="applicationcenter.footer.refund.policy">
                        {(message) => !message.toString().includes("applicationcenter.footer.refund.policy") ?
                    <div className="FooterLinks-item">
                                <a className="FooterLinks-link" href="#"
                                   onClick={() => popupWin("/application-center/terms-of-use/#" + message + "")}>
                                    <FormatMessage id="applicationcenter.footer.refund"/>
                                </a>
                    </div>: ""}
                    </FormatMessage>
                </div>
                <div className="SiteFooter-legalContainer">
                    <div className="SiteFooter-legalOptional">
                        <div className="RawHTML">
                            <p>
                                <span className="SiteFooter-disclaimerTitle">
                                    <FormatMessage id={`application.disclaimer.eq.title.${process.env.REACT_APP_SITE}`}>
                                        {(message) => !message.toString().includes(`application.disclaimer.eq.title.${process.env.REACT_APP_SITE}`) ? message : ""}
                                    </FormatMessage>
                                </span>
                                <FormatMessage id={`application.disclaimer.eq.text.${process.env.REACT_APP_SITE}`}>
                                {(message) => !message.toString().includes(`application.disclaimer.eq.text.${process.env.REACT_APP_SITE}`) ? message : ""}
                            </FormatMessage>
                            </p>
                            <p>
                                <FormatMessage id={`application.disclaimer.eq.subtext.${process.env.REACT_APP_SITE}`}>
                                    {(message) => !message.toString().includes(`application.disclaimer.eq.subtext.${process.env.REACT_APP_SITE}`) ? message : ""}
                                </FormatMessage>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="SiteFooter-copyright">
                    <FormatMessage id={`application.disclaimer.eq.copyright.${process.env.REACT_APP_SITE}`}/>
                </div>
            </div>
        </div>)
    }
}

export default EQFooter
